import { MaterialType } from "@enums/materialType.enum";

// Density (the PurchasableItem.weightConstant) for each material type, in the app's scale — density in
// g/cm³ multiplied by 1e-6, which is how weightConstant is stored (e.g. Steel 7.85 g/cm³ -> 0.00000785).
// Aluminium / Copper / Stainless / Steel are BPL's own values from existing materials; the rest use
// standard densities. Used to auto-populate density from the material type when adding a material.
export const MATERIAL_TYPE_DENSITY: { [key: number]: number } = {
	[MaterialType.Aluminium]: 0.00000269,
	[MaterialType.BDMS]: 0.00000785,
	[MaterialType.Brass]: 0.00000850,
	[MaterialType.Copper]: 0.00000893,
	[MaterialType.D2]: 0.00000770,
	[MaterialType.FCMS]: 0.00000785,
	[MaterialType.P20]: 0.00000785,
	[MaterialType.Polyurethane]: 0.00000120,
	[MaterialType.StainlessSteel]: 0.00000775,
	[MaterialType.Steel]: 0.00000785,
	[MaterialType.Tufnol]: 0.00000136,
	[MaterialType.NotApplicable]: 0,
};

export function densityForMaterialType(materialType: MaterialType): number {
	return MATERIAL_TYPE_DENSITY[materialType] ?? 0;
}
